var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "permission-group" }, [
    _vm.showAsCategory
      ? _c("div", { staticClass: "sub-entity-header" }, [
          _c(
            "button",
            {
              staticClass:
                "btn btn-light d-flex justify-content-between align-items-center w-100",
            },
            [
              _c("div", { staticClass: "sub-entity-title" }, [
                _c("span", { staticClass: "material-icons mr-2" }, [
                  _vm._v(_vm._s(_vm.getSubEntityIcon(_vm.subEntity.key))),
                ]),
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.subEntity.name) +
                    "\n            "
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "d-flex align-items-center" },
                [
                  _c("module-toggle", {
                    attrs: {
                      "is-active": _vm.isSubEntityFullySelected,
                      "is-partial": _vm.isSubEntityPartiallySelected,
                    },
                    on: { toggle: _vm.toggleAll },
                  }),
                ],
                1
              ),
            ]
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "permission-items",
        class: { "no-category": !_vm.showAsCategory },
      },
      _vm._l(_vm.subEntity.actions, function (permission) {
        return _c("permission-item", {
          key: permission._id,
          attrs: {
            permission: permission,
            "is-selected": _vm.isSelected(permission),
            "is-disabled": _vm.isDisabled(permission),
          },
          on: { toggle: _vm.togglePermission },
        })
      }),
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }